import React from "react";
import { Rect } from "react-konva";
import { BORDER_HEIGHT } from "../consts";
import { transformerRefAtom } from "state-atoms/general-atoms";
import { useAtomValue } from "jotai";
import useObservableController from "elements/hooks/use-observable-controller";
import { MONDAY_TASK_WIDTH, MONDAY_TASK_BASE_HEIGHT } from "shared/datamodel/monday-task";
import { IMondayTaskController } from "../controller";

export const MondayTaskBackground = React.memo(({ controller }: { controller: IMondayTaskController }) => {
  const transformerRef = useAtomValue(transformerRefAtom);
  useObservableController(controller, ["fill-changed", "color-by-changed", "item-changed"]);
  useObservableController(controller, ["size-changed"], () => {
    transformerRef?.current?.forceUpdate();
  });

  const { element } = controller;
  const { width = MONDAY_TASK_WIDTH, height = MONDAY_TASK_BASE_HEIGHT } = element;

  const borderColor = controller.getBorderColor();

  return (
    <>
      <Rect width={width} height={height} fill={borderColor} cornerRadius={10} />
      <Rect
        y={BORDER_HEIGHT}
        width={width}
        height={height}
        fill="white"
        cornerRadius={10}
        stroke="#EBEDF3"
        strokeWidth={1}
        hitStrokeWidth={0}
        shadowColor="black"
        shadowBlur={14}
        shadowOpacity={0.1}
        shadowForStrokeEnabled={false}
      />
    </>
  );
});

MondayTaskBackground.displayName = "MondayTaskBackground";
